export default {
  type: 'object',
  properties: {
    login: {
      title: 'schema.login.login',
      format: 'email',
      type: 'string',
      fieldRequired: true
    },
    password: {
      type: 'string',
      title: 'schema.login.password',
      fieldRequired: true
    }
  }
};
